import { html } from 'lit';
const ChatWithAi =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M3.755 7.913C2.741 6.996 3.35 5.25 4.765 5.25h14.237c1.18 0 1.878 1.279 1.317 2.278l-6.982 12.447c-.685 1.221-2.484.937-2.792-.408l-1.595-6.96zm6.727 4.667 1.525 6.652.005.016.01.002.006-.009L18.312 8.04zm7.064-5.83H4.761l-.007.013a.1.1 0 0 0-.004.025l.01.012 4.965 4.486z" clip-rule="evenodd"/>
  </svg>
`;
export default ChatWithAi;
